(() => {
 'use strict';
 const root=document.querySelector('.gl-living-root');if(!root)return;
 const dialog=root.querySelector('#gallery');
 const worlds=root.querySelector('.worlds'),heading=root.querySelector('#gallery-heading');
 const back=root.querySelector('.back-button'),intro=root.querySelector('.intro-note');
 const cards=[...root.querySelectorAll('.world')],panels=[...root.querySelectorAll('.view-panel')];
 const input=root.querySelector('#collection-search'),english=document.documentElement.lang==='en';
 const selectors=new Map([
  ['#indoor-categories','indoor-selector'],['#outdoor-categories','outdoor-selector'],
  ['#succulents-categories','succulents-selector'],['#pots-collections','pots'],['#care-categories','care']
 ]);
 const selectorViews=new Set(selectors.values());
 selectorViews.add('service');
 let opener,active=null,currentView='worlds',history=[],positionRevision=0,previousOverflow='';
 function resetWorlds(){
  active=null;worlds.classList.remove('has-active');
  cards.forEach(card=>{card.classList.remove('is-active');card.querySelector('.door').removeAttribute('aria-expanded');card.querySelector('.world-detail').hidden=true;});
 }
 function display(name){
  currentView=name;dialog.dataset.view=name;dialog.dataset.selector=String(selectorViews.has(name));
  resetWorlds();worlds.hidden=name!=='worlds';panels.forEach(p=>p.hidden=!p.classList.contains(name));
  heading.hidden=name!=='worlds';intro.hidden=name!=='worlds';back.hidden=name==='worlds';
  back.textContent=history.length||selectorViews.has(name)?(english?'← Back':'← Επιστροφή'):(english?'← All worlds':'← Όλοι οι κόσμοι');
 }
 function focusTarget(){
  if(currentView==='directory')return input;
  if(currentView==='worlds')return active?.querySelector('h2')||heading;
  return panels.find(p=>!p.hidden)?.querySelector('h2');
 }


 function position(target,top=0,detail=null,detailTop=0){
  const revision=++positionRevision;
  const apply=()=>{if(!dialog.open||revision!==positionRevision)return;
   dialog.scrollTop=top;if(detail)detail.scrollTop=detailTop;
  };
  if(target){if(!target.matches('a,button,input'))target.tabIndex=-1;target.focus({preventScroll:true});}
  apply();requestAnimationFrame(()=>{apply();requestAnimationFrame(apply);});
 }
 function expand(card){
  resetWorlds();active=card;worlds.classList.add('has-active');card.classList.add('is-active');
  card.querySelector('.door').setAttribute('aria-expanded','true');card.querySelector('.world-detail').hidden=false;
  heading.hidden=true;back.hidden=false;intro.hidden=false;
 }
 function snapshot(trigger){return {view:currentView,card:active,trigger,top:dialog.scrollTop,detailTop:active?.querySelector('.world-detail').scrollTop||0};}
 function open(name,trigger){
  opener=trigger;history=[];previousOverflow=document.body.style.overflow;
  display(name);dialog.showModal();document.body.style.overflow='hidden';position(focusTarget());
 }
 function navigate(name,trigger){
  if(!dialog.open){open(name,trigger);return;}
  history.push(snapshot(trigger));display(name);position(focusTarget());
 }
 function restore(){
  const origin=history.pop();if(!origin)return false;
  display(origin.view);if(origin.card)expand(origin.card);
  position(origin.trigger,origin.top,origin.card?.querySelector('.world-detail'),origin.detailTop);return true;
 }
 function close(){
  dialog.close();
 }


 // Keep the homepage's shopping choices aligned with the existing inner menu.
 const genusLinks=[{"text":"Monstera","gr":"/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AMonstera","en":"/en-eu/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AMonstera"},{"text":"Alocasia","gr":"/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AAlocasia","en":"/en-eu/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AAlocasia"},{"text":"Aglaonema","gr":"/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AAglaonema","en":"/en-eu/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AAglaonema"},{"text":"Ficus","gr":"/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AFicus","en":"/en-eu/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AFicus"},{"text":"Epipremnum","gr":"/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AEpipremnum","en":"/en-eu/collections/indoorplants?pf_t_eidos_fytoy=%CE%93%CE%AD%CE%BD%CE%BF%CF%82%3AEpipremnum"}];
 function labelLink(link,text){
  const walker=document.createTreeWalker(link,NodeFilter.SHOW_TEXT);
  let node;while((node=walker.nextNode())){if(node.textContent.trim()&&!node.parentElement.closest('[aria-hidden="true"],svg')){node.textContent=text;break;}}
 }
 function appendChoice(group,source,text,href){
  if(!group||!source||[...group.querySelectorAll('a[href]')].some(a=>a.getAttribute('href')===href))return;
  const link=source.cloneNode(true);link.setAttribute('href',href);labelLink(link,text);group.append(link);
 }
 const indoorSpecies=root.querySelector('.indoor-selector a[href$="/collections/philodendron"]')?.closest('.directory-group');
 const indoorDirectory=root.querySelector('.directory a[href$="/collections/philodendron"]')?.closest('.directory-group');
 for(const group of [indoorSpecies,indoorDirectory]){
  for(const item of genusLinks)appendChoice(group,group?.querySelector('a[href]'),item.text,english?item.en:item.gr);
 }
 for(const handle of ['baby-plants','carnivorous-plants','new','new-varieties']){
  const source=root.querySelector('.directory a[href$="/collections/'+handle+'"]');
  if(source)appendChoice(indoorSpecies,source,source.textContent.trim(),source.getAttribute('href'));
 }
 root.querySelectorAll('a[href]').forEach(link=>{
  const path=new URL(link.href,location.origin).pathname.replace(/\/$/,'');
  if(/\/collections\/(new|new-varieties)$/.test(path))labelLink(link,english?'New arrivals':'Νέες αφίξεις');
  if(path.endsWith('/collections/hydroculture')&&!new URL(link.href).search)labelLink(link,english?'Hydroculture':'Υδροκαλλιέργεια');
 });


 // Direct, keyboard-accessible access to the indoor menu groups.
 const indoorPanel=root.querySelector('.indoor-selector');
 if(indoorPanel){
  const groups=[...indoorPanel.querySelectorAll('.care-grid .directory-group')];
  const jumps=document.createElement('nav');jumps.className='selector-jumps';
  jumps.setAttribute('aria-label',english?'Jump to a plant group':'Μετάβαση σε ομάδα φυτών');
  const ordered=[groups[2],groups[0],groups[1]].filter(Boolean);
  ordered.forEach((group,index)=>{
   const title=group.querySelector('h3');if(!title)return;
   title.id='indoor-group-'+index;
   const link=document.createElement('a');link.href='#'+title.id;link.textContent=title.textContent.trim();
   link.addEventListener('click',event=>{
    event.preventDefault();
    const top=Math.max(0,dialog.scrollTop+title.getBoundingClientRect().top-dialog.getBoundingClientRect().top-24);
    position(title,top);
   });
   jumps.append(link);
  });
  indoorPanel.querySelector('.care-grid')?.before(jumps);
 }

 const shortcuts=document.createElement('div');shortcuts.className='gallery-shortcuts';
 const directoryButton=root.querySelector('.gallery-footer .index-button').cloneNode(true);
 directoryButton.classList.add('gallery-directory');
 const searchLabel=root.querySelector('.directory form button[type="submit"]')?.textContent.trim();
 if(searchLabel)directoryButton.append(document.createTextNode(' · '+searchLabel));
 const quickLinks=document.createElement('div');quickLinks.className='gallery-category-links';
 const succulent=root.querySelector('a[href="#succulents-categories"]');
 if(succulent)quickLinks.append(succulent.cloneNode(true));
 for(const handle of ['hydroculture','gardening']){
  const source=[...root.querySelectorAll('.directory a[href]')].find(a=>a.getAttribute('href').replace(/\/$/,'').endsWith('/collections/'+handle));
  if(source)quickLinks.append(source.cloneNode(true));
 }
 shortcuts.append(directoryButton,quickLinks);worlds.before(shortcuts);
 cards.forEach(card=>{
  const controls={indoor:'indoor-categories',outdoor:'outdoor-categories',pots:'pots-collections',care:'care-categories'};
  card.querySelector('.door').setAttribute('aria-controls',controls[card.dataset.world]);
  card.querySelector('.door').removeAttribute('aria-expanded');
 });

 root.querySelectorAll('[data-open]').forEach(button=>button.addEventListener('click',()=>open(button.dataset.open,button)));
 root.querySelectorAll('[data-view]').forEach(button=>button.addEventListener('click',()=>navigate(button.dataset.view,button)));
 root.querySelector('.close-button').addEventListener('click',close);
 document.addEventListener('click',event=>{
  const link=event.target.closest('a[href]'),name=link&&selectors.get(link.getAttribute('href'));
  if(name){event.preventDefault();navigate(name,link);}
 });
 cards.forEach(card=>card.querySelector('.door').addEventListener('click',()=>{
  const destinations={indoor:'indoor-selector',outdoor:'outdoor-selector',pots:'pots',care:'care'};
  navigate(destinations[card.dataset.world],card.querySelector('.door'));
 }));
 back.addEventListener('click',()=>{
  if(restore())return;
  if(selectorViews.has(currentView)){dialog.close();return;}
  const last=active;display('worlds');position(last?.querySelector('.door')||cards[0].querySelector('.door'));
 });
 dialog.addEventListener('keydown',event=>{
  if(event.target.closest('#md-app-embed__modal')){if(event.key==='Escape')event.preventDefault();return;}
  if(event.key==='Escape'){event.preventDefault();event.stopPropagation();close();return;}
  if(event.key!=='Tab')return;
  const items=[...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length);
  const first=items[0],last=items.at(-1);
  if(event.shiftKey&&(document.activeElement===first||!items.includes(document.activeElement))){event.preventDefault();last?.focus();}
  else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
 },true);
 dialog.addEventListener('close',()=>{
  ++positionRevision;history=[];document.body.style.overflow=previousOverflow;
  opener?.focus({preventScroll:true});
 });

 if(location.hash==='#pots-collections')open('pots',root.querySelector('.explore-pill'));
 else if(new URLSearchParams(location.search).has('explore'))open('worlds',root.querySelector('.explore-pill'));
})();

